/**
 * Ссылка на публичный профиль участника в клиентском приложении.
 */
export function clientMemberProfileLink(author) {
  if (!author?.id) return null;
  const role = author.role;
  if (role === "client") return `/app/members/${author.id}`;
  return null;
}
